import React, { FC } from "react";
import AIHistoryIcon from "../../static/svg/AIHistoryIcon";
import { log } from "console";

interface SidebarItemProps {
  text: string;
  onClick?: () => void;
  isActive?: boolean;
  isDarkMode?: boolean;  // Add this
  style?: React.CSSProperties;
}


const HistorySidebarItem: FC<SidebarItemProps> = ({ text, onClick, isActive, isDarkMode }) => {

  console.log(isDarkMode);
  
  return (
    <div
      className={`history-item d-flex align-items-center cursor-pointer `}
      onClick={onClick}
    >
      <AIHistoryIcon />
      <span className={`ms-2 p-2 ${isActive ? (isDarkMode ? "active-item-dark" : "active-item-light") : ""}`}>
        {text.length > 25 ? text.slice(0, 25) + "..." : text}
      </span>

    </div>
  );
};

export default HistorySidebarItem;
